// removed by extract-text-webpack-plugin
module.exports = {"loader":"Loader__loader___1-XkB","loader--sm":"Loader__loader--sm___E45zh","loader--med":"Loader__loader--med___20Xcv","loader--lg":"Loader__loader--lg___2_AUz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/indicators/Loader.scss
// module id = 97
// module chunks = 0